var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 152,
    viewBox: "0 0 82 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 1.58399C36.994 4.54199 28.365 12.941 24.903 24.063C23.464 28.687 23 33.197 23 42.556V54.934L11.75 55.217L0.500003 55.5L0.221004 69.363C0.0330041 78.732 0.315002 83.675 1.093 84.613C1.94 85.632 4.99001 86 12.609 86H22.973L23.236 118.75L23.5 151.5L37.864 151.778C47.603 151.967 52.674 151.686 53.614 150.906C54.742 149.969 55 143.832 55 117.878V86L66.75 85.985C73.213 85.976 79.075 85.604 79.779 85.158C80.742 84.547 80.988 80.792 80.779 69.923L80.5 55.5L67.75 55.22L55 54.94V45.026C55 36.175 55.242 34.83 57.259 32.486C59.358 30.045 60.293 29.812 70.509 29.18L81.5 28.5V14.5V0.49999L67.5 0.30199C57.735 0.16499 51.836 0.55199 48 1.58399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ae89f4a433fae5dcb205294f273c22d7.svg";
export { ForwardRef as ReactComponent };